package com.sddamico.draftmachine.models

import com.sddamico.draftmachine.data.ExternalProvider
import com.sddamico.draftmachine.data.OwnershipSyncStatus
import com.sddamico.draftmachine.data.Sport
import kotlinx.serialization.Serializable

// Frontend mirrors of the jvmMain league-ownership DTOs. Same package, same field names and
// nullability — serialization matches by shape, so change one side and you must change the other.

@Serializable
data class LeagueConnectionResponse(
  val leagueId: String,
  val provider: ExternalProvider,
  val externalLeagueId: String,
  val externalSeason: Int? = null,
  val sport: Sport,
  val hasCredentials: Boolean,
  val createdAt: String,
  val updatedAt: String,
)

@Serializable
data class OwnershipSyncResponse(
  val id: String,
  val leagueId: String,
  val status: OwnershipSyncStatus,
  val startedAt: String? = null,
  val finishedAt: String? = null,
  val ownedCount: Int = 0,
  val matchedCount: Int = 0,
  val unmatchedCount: Int = 0,
  val teamsMappedCount: Int = 0,
  val errorMessage: String? = null,
  val triggeredBy: String? = null,
)

@Serializable
data class LeagueConnectionStateResponse(
  val leagueName: String,
  val connection: LeagueConnectionResponse? = null,
  val latestSync: OwnershipSyncResponse? = null,
)

@Serializable
data class SaveLeagueConnectionRequest(
  val leagueId: String,
  val provider: ExternalProvider,
  val externalLeagueId: String,
  val externalSeason: Int? = null,
  val sport: Sport,
  val userSecretId: String? = null,
  val espnS2: String? = null,
  val espnSwid: String? = null,
)

@Serializable
data class TriggerOwnershipSyncRequest(val leagueId: String)

@Serializable
data class FantraxLeagueOption(
  val leagueId: String,
  val leagueName: String,
  val teamName: String? = null,
  val sport: Sport? = null,
)

@Serializable
data class LookupFantraxLeaguesRequest(val userSecretId: String)

@Serializable
data class FantraxTeamOption(
  val teamId: String,
  val teamName: String,
)

@Serializable
data class LookupFantraxTeamsRequest(val externalLeagueId: String)

@Serializable
data class LookupEspnLeagueRequest(
  val externalLeagueId: String,
  val sport: Sport,
  val season: Int,
  val espnS2: String,
  val espnSwid: String,
)

@Serializable
data class EspnTeamOption(
  val teamId: String,
  val teamName: String,
  val ownerNames: List<String> = emptyList(),
  val credentialOwner: Boolean = false,
)

@Serializable
data class EspnLeaguePreview(
  val leagueId: String,
  val leagueName: String,
  val sport: Sport,
  val season: Int,
  val teams: List<EspnTeamOption> = emptyList(),
)

@Serializable
data class OwnedPlayerResponse(
  val playerId: String? = null,
  val playerName: String,
  val playerPosition: String? = null,
  val ownerTeamId: String? = null,
  val ownerTeamName: String,
)
